import { showInputError } from "../../../shared/input-handler";
export class Currency {
    constructor(form) {
        this.form = form;
        this.element = form.querySelector("select#currency");
    }
    addToFormData(formData) {
        formData.append(this.element.name, this.element.value);
    }
    validate() {
        if (this.isEmpty()) {
            showInputError(this.element, requiredField);
            return false;
        }
        return true;
    }
    isEmpty() {
        return this.element.value === "";
    }
}
